<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="section-title">{{ isEditMode() ? 'Editar Tarifa' : 'Nueva Tarifa' }}</h1>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Modifica la información de la tarifa' : 'Completa los datos para crear una nueva tarifa' }}
        </p>
      </div>
      <div class="flex gap-2">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-outlined"
          (click)="onCancel()"
          [disabled]="loading()">
        </button>
        <button
          pButton
          type="button"
          [label]="isEditMode() ? 'Guardar Cambios' : 'Crear Tarifa'"
          [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-plus'"
          class="p-button"
          (click)="onSubmit()"
          [disabled]="loading()"
          [loading]="loading()">
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="app-page-content edit-layout">
    <form [formGroup]="tarifaForm" (ngSubmit)="onSubmit()" id="tarifaForm" class="edit-form">
      <div class="app-card">
        <!-- Form Title -->
        <h2 class="text-xl font-semibold mb-6" style="color: hsl(var(--text));">
          {{ isEditMode() ? 'Datos de la Tarifa' : 'Datos Generales' }}
        </h2>

        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
          <!-- Código -->
          <div class="space-y-2">
            <label for="codigo" class="text-sm font-medium" style="color: hsl(var(--text));">
              Código *
            </label>
            <input
              pInputText
              id="codigo"
              formControlName="codigo"
              type="text"
              placeholder="Ej: TAR-001"
              class="w-full"
              [class.border-red-500]="hasError('codigo', 'required') || hasError('codigo', 'maxlength')"
            />
            @if (hasError('codigo', 'required') || hasError('codigo', 'maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ getErrorMessage('codigo') }}
              </small>
            }
          </div>

          <!-- Nombre -->
          <div class="space-y-2">
            <label for="nombre" class="text-sm font-medium" style="color: hsl(var(--text));">
              Nombre *
            </label>
            <input
              pInputText
              id="nombre"
              formControlName="nombre"
              type="text"
              placeholder="Ej: Tarifa Básica"
              class="w-full"
              [class.border-red-500]="hasError('nombre', 'required') || hasError('nombre', 'maxlength')"
            />
            @if (hasError('nombre', 'required') || hasError('nombre', 'maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ getErrorMessage('nombre') }}
              </small>
            }
          </div>

          <!-- Descripción -->
          <div class="space-y-2 md:col-span-2">
            <label for="descripcion" class="text-sm font-medium" style="color: hsl(var(--text));">
              Descripción
            </label>
            <textarea
              pTextarea
              id="descripcion"
              formControlName="descripcion"
              rows="3"
              placeholder="Descripción detallada de la tarifa"
              class="w-full"
              [class.border-red-500]="hasError('descripcion', 'maxlength')">
            </textarea>
            @if (hasError('descripcion', 'maxlength')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ getErrorMessage('descripcion') }}
              </small>
            }
          </div>

          <!-- Vigencia Desde -->
          <div class="space-y-2">
            <label for="vigenciaDesde" class="text-sm font-medium" style="color: hsl(var(--text));">
              Vigencia Desde *
            </label>
            <p-datepicker
              inputId="vigenciaDesde"
              formControlName="vigenciaDesde"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              iconDisplay="input"
              placeholder="Seleccionar fecha"
              [showButtonBar]="true"
              [styleClass]="hasError('vigenciaDesde', 'required') ? 'border-red-500 w-full' : 'w-full'">
            </p-datepicker>
            @if (hasError('vigenciaDesde', 'required')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ getErrorMessage('vigenciaDesde') }}
              </small>
            }
          </div>

          <!-- Vigencia Hasta -->
          <div class="space-y-2">
            <label for="vigenciaHasta" class="text-sm font-medium" style="color: hsl(var(--text));">
              Vigencia Hasta *
            </label>
            <p-datepicker
              inputId="vigenciaHasta"
              formControlName="vigenciaHasta"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              iconDisplay="input"
              placeholder="Seleccionar fecha"
              [showButtonBar]="true"
              [styleClass]="hasError('vigenciaHasta', 'required') ? 'border-red-500 w-full' : 'w-full'">
            </p-datepicker>
            @if (hasError('vigenciaHasta', 'required')) {
              <small class="text-sm block" style="color: hsl(var(--danger));">
                {{ getErrorMessage('vigenciaHasta') }}
              </small>
            }
          </div>

          <!-- Activa -->
          <div class="space-y-2 md:col-span-2">
            <div class="flex items-center gap-3">
              <p-toggleswitch
                inputId="active"
                formControlName="active">
              </p-toggleswitch>
              <label for="active" class="text-sm font-medium cursor-pointer" style="color: hsl(var(--text));">
                Tarifa Activa
              </label>
            </div>
            <p class="text-xs" style="color: hsl(var(--muted));">
              Las tarifas actives están disponibles para su uso en el sistema
            </p>
          </div>
        </div>
      </div>

      <div class="app-card mt-6">
        <div class="tarifa-detalles-heading">
          <div>
            <h2 class="text-xl font-semibold" style="color: hsl(var(--text));">Detalles del Tarifario</h2>
            <p class="text-sm text-muted">Reglas y precios por tipo de producto</p>
          </div>
        </div>

        <div class="tarifa-detalles-tabs" role="tablist" aria-label="Tipos de producto">
          <button
            *ngFor="let tab of tipoTabs(); trackBy: trackTipoTab"
            type="button"
            class="tarifa-tab"
            [class.is-active]="activeTipoCodigo() === tab.codigo"
            (click)="selectTipoTab(tab.codigo)">
            <span class="tab-label">{{ tab.label }}</span>
            <span class="tab-count">{{ getTabCounts(tab.codigo).total }}</span>
            @if (getTabCounts(tab.codigo).invalid > 0) {
              <span class="tab-badge error">Inv {{ getTabCounts(tab.codigo).invalid }}</span>
            }
            @if (getTabCounts(tab.codigo).overlaps > 0) {
              <span class="tab-badge warn">Sol {{ getTabCounts(tab.codigo).overlaps }}</span>
            }
            @if (getTabCounts(tab.codigo).duplicates > 0) {
              <span class="tab-badge warn">Dup {{ getTabCounts(tab.codigo).duplicates }}</span>
            }
          </button>
        </div>

        <div class="tarifa-detalles-toolbar">
          <div>
            <h3 class="text-lg font-semibold" style="color: hsl(var(--text));">
              {{ getActiveTab()?.label || 'Detalles' }}
            </h3>
            <p class="text-xs text-muted">Validaciones por fila y clave de matching.</p>
          </div>
          <div class="toolbar-actions">
            <label class="toggle-inconsistencies">
              <input
                type="checkbox"
                [checked]="getInconsistenciesToggle(activeTipoCodigo())"
                (change)="toggleInconsistencies(activeTipoCodigo())" />
              <span>Solo inconsistencias</span>
            </label>
            <span class="filter-count">
              Mostrando {{ getFilterCounts(activeTipoCodigo()).shown }} de {{ getFilterCounts(activeTipoCodigo()).total }}
            </span>
            <button
              pButton
              type="button"
              icon="pi pi-plus"
              label="Agregar detalle"
              class="p-button-sm"
              [disabled]="!activeTipoCodigo() || activeTipoCodigo() === '__SIN_TIPO__'"
              (click)="addDetalleForTipo(activeTipoCodigo())">
            </button>
          </div>
        </div>

        <div class="tarifa-detalles-issues">
          @if (getGroupedIssues().length > 0) {
            <div class="issues-header">
              <span>Problemas detectados</span>
              <span class="issues-count">{{ getGroupedIssues().length }}</span>
            </div>
            <div class="issues-list">
              <div class="issue-group" *ngFor="let issue of getGroupedIssues(); trackBy: trackIssue">
                <div class="issue-row">
                  <span class="issue-type" [class.error]="issue.type === 'ERROR'" [class.warn]="issue.type === 'WARN'">
                    {{ issue.type }}
                  </span>
                  <span class="issue-ref">Fila {{ issue.rowIndex + 1 }}{{ issue.detalleId ? ' · ID ' + issue.detalleId : '' }} · {{ issue.code }}</span>
                  <span class="issue-fields">{{ issue.count > 0 ? (issue.code === 'DUPLICATE' ? ('Duplicado exacto con ' + issue.count + ' filas') : ('Solapa con ' + issue.count + ' filas')) : issue.message }}</span>
                  <div class="issue-actions">
                    @if (issue.code === 'DUPLICATE') {
                      <button
                        pButton
                        type="button"
                        label="Resolver"
                        class="p-button-text p-button-sm"
                        (click)="openResolveDuplicate(issue)">
                      </button>
                    } @else {
                      <button
                        pButton
                        type="button"
                        label="Ir"
                        class="p-button-text p-button-sm"
                        (click)="focusGroupedIssue(issue)">
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="issues-empty">
              Sin problemas en este tipo de producto.
            </div>
          }
        </div>

        <div class="tarifa-detalles-layout">
          <div class="tarifa-detalles-master" tabindex="0" (keydown)="handleListKeydown($event)">
            <div class="tarifa-detalles-header">
              <div class="row-main">
                <div class="cell tipo">Tipo Producto</div>
                <div class="cell unidad">Unidad</div>
                <div class="cell precio">Precio</div>
                <div class="cell prioridad">Prioridad</div>
              </div>
              <div class="row-secondary">
                <div class="cell condicion">Condición</div>
                <div class="cell acciones">Acciones</div>
              </div>
            </div>

            @if (getDetalleRowsForTipoFiltered(activeTipoCodigo()).length === 0) {
              <div class="tarifa-detalles-empty">
                No hay detalles cargados en este tipo.
              </div>
            }

            <div
              *ngFor="let row of getDetalleRowsForTipoFiltered(activeTipoCodigo()); trackBy: trackDetalleRow"
              class="tarifa-detalles-row"
              [class.is-selected]="selectedDetalleIndex() === row.index"
              [class.is-error]="rowHasError(row.index)"
              [class.is-warning]="rowHasWarning(row.index)"
              [class.is-highlighted]="rowIsHighlighted(row.index)"
              [attr.data-detalle-index]="row.index"
              [formGroup]="row.group"
              (click)="selectDetalle(row.index)">
              <div class="row-main">
                <div class="cell tipo">
                  <div class="cell-label">Tipo Producto</div>
                  <div class="cell-value">
                    {{ getDetalleTipoProducto(row.group)?.nombre || getDetalleTipoProducto(row.group)?.codigo || 'Sin tipo' }}
                  </div>
                </div>

                <div class="cell unidad">
                  <div class="cell-label">Unidad</div>
                  <div class="cell-value">
                    {{ row.group.get('unidadTarifacion')?.value || '-' }}
                  </div>
                </div>

                <div class="cell precio">
                  <div class="cell-label">Precio</div>
                  <p-inputNumber
                    formControlName="precioUnitario"
                    [min]="0"
                    mode="decimal"
                    class="w-full">
                  </p-inputNumber>
                </div>

                <div class="cell prioridad">
                  <div class="cell-label">Prioridad</div>
                  <p-inputNumber
                    formControlName="prioridad"
                    [min]="0"
                    [maxFractionDigits]="0"
                    class="w-full">
                  </p-inputNumber>
                </div>
              </div>

              <div class="row-secondary">
                <div class="cell condicion">
                  <div class="cell-label">Condición</div>
                  <div class="tarifa-detalles-chips">
                    <span class="tarifa-detalles-chip" *ngFor="let chip of getDetalleChips(row.group)">
                      {{ chip }}
                    </span>
                  </div>
                  <div class="tarifa-detalles-key">KEY: {{ getRowMatchingKey(row.index) }}</div>
                </div>

                <div class="cell acciones" (click)="$event.stopPropagation()">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-text p-button-sm"
                    (click)="selectDetalle(row.index)">
                  </button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-copy"
                    class="p-button-text p-button-sm"
                    (click)="duplicateDetalle(row.index)">
                  </button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-text p-button-danger p-button-sm"
                    (click)="deleteDetalle(row.index)">
                  </button>
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="getSelectedDetalleForm() as detalleForm">
            <div class="tarifa-detalles-panel" [formGroup]="detalleForm" (keydown)="handleDetallePanelKeydown($event)">
              <div class="panel-header">
                <div>
                  <h3 class="text-lg font-semibold" style="color: hsl(var(--text));">Editar detalle</h3>
                  <p class="text-xs text-muted">
                    {{ getDetalleTipoProducto(detalleForm)?.codigo || 'Seleccioná un tipo' }}
                  </p>
                  @if (detalleForm.dirty || !detalleForm.get('id')?.value) {
                    <span class="tab-badge warn">Pendiente de guardar</span>
                  }
                </div>
                <div class="flex items-center gap-2">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-save"
                    class="p-button-text p-button-sm"
                    (click)="saveSelectedDetalle()">
                  </button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-times"
                    class="p-button-text p-button-sm"
                    (click)="closeDetallePanel()">
                  </button>
                </div>
              </div>

              <div class="panel-body">
                <div class="grid grid-cols-1 gap-4">
                  <div class="space-y-2" data-detalle-field="tipoProductoId">
                    <label class="text-sm font-medium" style="color: hsl(var(--text));">Tipo Producto *</label>
                    <p-select
                      formControlName="tipoProductoId"
                      [options]="tipoProductoOptions()"
                      optionLabel="nombre"
                      optionValue="id"
                      placeholder="Tipo producto"
                      [appendTo]="'body'"
                      class="w-full">
                      <ng-template let-option pTemplate="item">
                        <div class="flex flex-col">
                          <span class="font-medium">{{ option?.codigo }}</span>
                          <span class="text-xs text-muted">{{ option?.nombre }}</span>
                        </div>
                      </ng-template>
                    </p-select>
                    @if (shouldShowDetalleFieldError(detalleForm, 'tipoProductoId')) {
                      <small class="field-error">{{ getDetalleFieldErrorMessage(detalleForm, 'tipoProductoId') }}</small>
                    }
                  </div>

                  <div class="space-y-2" data-detalle-field="unidadTarifacion">
                    <label class="text-sm font-medium" style="color: hsl(var(--text));">Unidad</label>
                    <input
                      pInputText
                      formControlName="unidadTarifacion"
                      class="w-full"
                      readonly />
                    <p class="text-xs text-muted">Se completa según el tipo de producto seleccionado.</p>
                  </div>

                  <div class="space-y-2" data-detalle-field="precioUnitario">
                    <label class="text-sm font-medium" style="color: hsl(var(--text));">Precio *</label>
                    <p-inputNumber
                      formControlName="precioUnitario"
                      [min]="0"
                      mode="decimal"
                      class="w-full">
                    </p-inputNumber>
                    @if (shouldShowDetalleFieldError(detalleForm, 'precioUnitario')) {
                      <small class="field-error">{{ getDetalleFieldErrorMessage(detalleForm, 'precioUnitario') }}</small>
                    }
                  </div>

                  <div class="space-y-2">
                    <label class="text-sm font-medium" style="color: hsl(var(--text));">Prioridad</label>
                    <p-inputNumber
                      formControlName="prioridad"
                      [min]="0"
                      [maxFractionDigits]="0"
                      class="w-full">
                    </p-inputNumber>
                  </div>
                </div>

                @if (isCanalAire(detalleForm)) {
                  <div class="panel-section">
                    <h4 class="panel-section-title">Condiciones Aire</h4>
                    <div class="grid grid-cols-1 gap-4">
                      <div class="space-y-2" data-detalle-field="diaTipo">
                        <label class="text-sm font-medium" style="color: hsl(var(--text));">Día grupo</label>
                        <p-select
                          formControlName="diaTipo"
                          [options]="diaTipoOptions"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Día"
                          [appendTo]="'body'"
                          class="w-full">
                        </p-select>
                        @if (shouldShowDetalleFieldError(detalleForm, 'diaTipo')) {
                          <small class="field-error">{{ getDetalleFieldErrorMessage(detalleForm, 'diaTipo') }}</small>
                        }
                      </div>

                      <div class="grid grid-cols-2 gap-3">
                        <div class="space-y-2" data-detalle-field="horaDesde">
                          <label class="text-sm font-medium" style="color: hsl(var(--text));">Hora desde</label>
                          <p-datepicker
                            formControlName="horaDesde"
                            [timeOnly]="true"
                            hourFormat="24"
                            [appendTo]="'body'"
                            class="w-full">
                          </p-datepicker>
                          @if (shouldShowDetalleFieldError(detalleForm, 'horaDesde')) {
                            <small class="field-error">{{ getDetalleFieldErrorMessage(detalleForm, 'horaDesde') }}</small>
                          }
                        </div>
                        <div class="space-y-2" data-detalle-field="horaHasta">
                          <label class="text-sm font-medium" style="color: hsl(var(--text));">Hora hasta</label>
                          <p-datepicker
                            formControlName="horaHasta"
                            [timeOnly]="true"
                            hourFormat="24"
                            [appendTo]="'body'"
                            class="w-full">
                          </p-datepicker>
                          @if (shouldShowDetalleFieldError(detalleForm, 'horaHasta')) {
                            <small class="field-error">{{ getDetalleFieldErrorMessage(detalleForm, 'horaHasta') }}</small>
                          }
                        </div>
                      </div>

                      <div class="space-y-2" data-detalle-field="programa">
                        <label class="text-sm font-medium" style="color: hsl(var(--text));">Programa</label>
                        <p-autoComplete
                          formControlName="programa"
                          [suggestions]="programaSuggestions()"
                          (completeMethod)="searchProgramas($event)"
                          optionLabel="displayName"
                          dataKey="id"
                          field="displayName"
                          placeholder="Programa"
                          [dropdown]="true"
                          [appendTo]="'body'"
                          class="w-full">
                          <ng-template let-option pTemplate="item">
                            <div class="flex flex-col">
                              <span class="font-medium">{{ option?.codigo }}</span>
                              <span class="text-xs text-muted">{{ option?.nombre }}</span>
                            </div>
                          </ng-template>
                        </p-autoComplete>
                      </div>

                      <div class="space-y-2" data-detalle-field="tipoMaterial">
                        <label class="text-sm font-medium" style="color: hsl(var(--text));">Tipo Material</label>
                        <p-autoComplete
                          formControlName="tipoMaterial"
                          [suggestions]="tipoMaterialSuggestions()"
                          (completeMethod)="searchTipoMaterial($event)"
                          optionLabel="displayName"
                          dataKey="id"
                          field="displayName"
                          placeholder="Tipo Material"
                          [dropdown]="true"
                          [appendTo]="'body'"
                          class="w-full">
                          <ng-template let-option pTemplate="item">
                            <div class="flex flex-col">
                              <span class="font-medium">{{ option?.codigo }}</span>
                              <span class="text-xs text-muted">{{ option?.nombre }}</span>
                            </div>
                          </ng-template>
                        </p-autoComplete>
                      </div>
                    </div>
                  </div>
                }

                @if (isCanalDigital(detalleForm)) {
                  <div class="panel-section">
                    <h4 class="panel-section-title">Condiciones Digital</h4>
                    <div class="grid grid-cols-1 gap-4">
                      <div class="space-y-2" data-detalle-field="formatoDigital">
                        <label class="text-sm font-medium" style="color: hsl(var(--text));">Formato</label>
                        <p-autoComplete
                          formControlName="formatoDigital"
                          [suggestions]="formatoDigitalSuggestions()"
                          (completeMethod)="searchFormatoDigital($event)"
                          optionLabel="displayName"
                          dataKey="id"
                          field="displayName"
                          placeholder="Formato"
                          [dropdown]="true"
                          [appendTo]="'body'"
                          class="w-full">
                        </p-autoComplete>
                        @if (shouldShowDetalleFieldError(detalleForm, 'formatoDigital')) {
                          <small class="field-error">{{ getDetalleFieldErrorMessage(detalleForm, 'formatoDigital') }}</small>
                        }
                      </div>

                      <div class="space-y-2" data-detalle-field="ubicacionDigital">
                        <label class="text-sm font-medium" style="color: hsl(var(--text));">Ubicación</label>
                        <p-autoComplete
                          formControlName="ubicacionDigital"
                          [suggestions]="ubicacionDigitalSuggestions()"
                          (completeMethod)="searchUbicacionDigital($event)"
                          optionLabel="displayName"
                          dataKey="id"
                          field="displayName"
                          placeholder="Ubicación"
                          [dropdown]="true"
                          [appendTo]="'body'"
                          class="w-full">
                        </p-autoComplete>
                        @if (shouldShowDetalleFieldError(detalleForm, 'ubicacionDigital')) {
                          <small class="field-error">{{ getDetalleFieldErrorMessage(detalleForm, 'ubicacionDigital') }}</small>
                        }
                      </div>

                      @if (isCanalRedes(detalleForm)) {
                        <div class="space-y-2" data-detalle-field="plataformaRedes">
                          <label class="text-sm font-medium" style="color: hsl(var(--text));">Plataforma</label>
                          <input
                            pInputText
                            formControlName="plataformaRedes"
                            placeholder="Instagram, Facebook..."
                            class="w-full" />
                          @if (shouldShowDetalleFieldError(detalleForm, 'plataformaRedes')) {
                            <small class="field-error">{{ getDetalleFieldErrorMessage(detalleForm, 'plataformaRedes') }}</small>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
</div>

<p-dialog
  header="Solapamientos detectados"
  [visible]="showWarningsDialog()"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '520px' }"
  [appendTo]="'body'"
  (onHide)="cancelSaveWithWarnings()">
  <div class="warnings-content">
    <p class="text-sm text-muted mb-3">
      Hay solapamientos entre detalles. Podés guardar igual, pero revisá los rangos.
    </p>
    <div class="warnings-list">
      <div class="warning-row" *ngFor="let warning of getWarningIssues(); trackBy: trackIssue">
        <span class="warning-type">WARN</span>
        <span class="warning-ref">Fila {{ warning.rowIndex + 1 }}{{ warning.detalleId ? ' · ID ' + warning.detalleId : '' }}</span>
        <span class="warning-message">{{ warning.message }}</span>
      </div>
    </div>
    <div class="flex justify-end gap-2 pt-3">
      <button pButton type="button" label="Cancelar" class="p-button-text" (click)="cancelSaveWithWarnings()"></button>
      <button pButton type="button" label="Guardar igual" (click)="confirmSaveWithWarnings()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Duplicado detectado"
  [visible]="resolveDialogVisible()"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '720px' }"
  [appendTo]="'body'"
  (onHide)="closeResolveDuplicate()">
  <div class="compare-content">
    <div class="compare-key">KEY: {{ resolveKey() }}</div>

    @if (resolveDetalleIds().length > 2) {
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
        <div class="space-y-2">
          <label class="text-sm font-medium" style="color: hsl(var(--text));">Seleccionar A</label>
          <select class="w-full" [ngModel]="resolveAId()" (ngModelChange)="resolveAId.set($event)">
            <option *ngFor="let id of resolveDetalleIds()" [ngValue]="id">ID {{ id }}</option>
          </select>
        </div>
        <div class="space-y-2">
          <label class="text-sm font-medium" style="color: hsl(var(--text));">Seleccionar B</label>
          <select class="w-full" [ngModel]="resolveBId()" (ngModelChange)="resolveBId.set($event)">
            <option *ngFor="let id of resolveDetalleIds()" [ngValue]="id">ID {{ id }}</option>
          </select>
        </div>
      </div>
    }

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="app-card" *ngIf="getResolveDetalleSnapshot(resolveAId()) as detalleA">
        <div class="flex items-center justify-between mb-2">
          <div class="text-sm font-semibold">Detalle A · ID {{ detalleA.id }}</div>
          <button pButton type="button" label="Eliminar este" class="p-button-danger p-button-sm" (click)="resolveDeleteDetalle(detalleA.id ?? null)"></button>
        </div>
        <div class="text-xs text-muted mb-2">{{ formatEntityLabel(detalleA.tipoProducto) }}</div>
        <div class="text-sm">Unidad: <strong>{{ detalleA.unidadTarifacion || '-' }}</strong></div>
        <div class="text-sm">Precio: <strong>{{ detalleA.precioUnitario || '-' }}</strong></div>
        <div class="text-sm">Prioridad: <strong>{{ detalleA.prioridad || 0 }}</strong></div>
        <div class="tarifa-detalles-chips mt-3">
          <span class="tarifa-detalles-chip" *ngFor="let chip of getDetalleChipsFromSnapshot(detalleA)">{{ chip }}</span>
        </div>
        <div class="tarifa-detalles-key mt-2">KEY: {{ resolveKey() }}</div>
      </div>

      <div class="app-card" *ngIf="getResolveDetalleSnapshot(resolveBId()) as detalleB">
        <div class="flex items-center justify-between mb-2">
          <div class="text-sm font-semibold">Detalle B · ID {{ detalleB.id }}</div>
          <button pButton type="button" label="Eliminar este" class="p-button-danger p-button-sm" (click)="resolveDeleteDetalle(detalleB.id ?? null)"></button>
        </div>
        <div class="text-xs text-muted mb-2">{{ formatEntityLabel(detalleB.tipoProducto) }}</div>
        <div class="text-sm">Unidad: <strong>{{ detalleB.unidadTarifacion || '-' }}</strong></div>
        <div class="text-sm">Precio: <strong>{{ detalleB.precioUnitario || '-' }}</strong></div>
        <div class="text-sm">Prioridad: <strong>{{ detalleB.prioridad || 0 }}</strong></div>
        <div class="tarifa-detalles-chips mt-3">
          <span class="tarifa-detalles-chip" *ngFor="let chip of getDetalleChipsFromSnapshot(detalleB)">{{ chip }}</span>
        </div>
        <div class="tarifa-detalles-key mt-2">KEY: {{ resolveKey() }}</div>
      </div>
    </div>

    <div class="compare-actions">
      <button pButton type="button" label="Cerrar" (click)="closeResolveDuplicate()"></button>
    </div>
  </div>
</p-dialog>
